import styled from '@emotion/styled';
import { MenuItemsNavigation } from 'src/components/Menu/Menu.style';

export const SubmenuItemsNavigationSettings = styled(MenuItemsNavigation, { label: 'SubmenuItemsNavigationSettings' })`
    flex: 0 0 200px;
    width: 200px;
`;

export const AdminSettingsContainer = styled('div', { label: 'AdminSettingsContainer' })`
    flex: 0 0 calc(100% - 200px);
    padding: 24px;
    width: calc(100% - 200px);
`;
